import { VisitAttachment } from "./scheduleApi"

const videoExtensions = ['.mp4', '.mov', '.webm', '.avi', '.mkv', '.m4v']

// Same rule as the API's VisitDTO.HasPhotos (AttachmentsRepository.LoadVisitIdsWithPhotosAsync): a live visit attachment with a thumbnail.
export const visitPhotosOf = (attachments: VisitAttachment[] | undefined): VisitAttachment[] =>
  (attachments ?? []).filter(attachment => !!attachment.thumbnail)

export const isVideo = (attachment: VisitAttachment): boolean => {
  const path = attachment.path.toLowerCase()
  return videoExtensions.some(ext => path.endsWith(ext))
}
